import * as ts from "../../common/Translator";
import {translate, translateId} from "../../common/Translator";
import {isNullOrUndefined} from "../../common/NamaCommon";
import * as EditScreenFieldLayout from "../../constants/EditScreenFieldLayout";
import * as meta from "../../common/Metadata";
import {findFieldMetadata} from "../../common/Metadata";
import {getEntityImageInfo, isFeatureEnabled, shouldShowHelpMsgs} from "../../login/ClientCache";
import {userCanViewField} from "../../login/Security";
import {getFieldWidth, intiWidget_} from "../../widgets/FieldWidgetCreator";
import {isMobileDevice, shouldAddMainFileWidget} from "../../common/GUIUtilities";
import {AttachmentWidget} from "../../widgets/AttachmentWidget";
import {createFieldMetadata} from "../../common/ExpressionEditUtility";
import {findHelpMsgAndShowIt} from "../../common/ErrorsNotification";
import * as FieldType from "../../constants/FieldType";
import {BooleanFieldWidget} from "../../widgets/BooleanFieldWidget";
import * as CommonConstants from "../../constants/CommonConstants";

export function setItemCollapseAttr(presenter, groupHeader, groupId, defaultIsCollapse) {
    let collapseId = presenter ? presenter.entityType + CommonConstants.SEPARATOR : "";
    if (presenter && presenter.viewName_ && presenter.viewName_())
        collapseId += presenter.viewName_() + CommonConstants.SEPARATOR;
    if (groupId)
        collapseId += groupId + CommonConstants.SEPARATOR;
    groupHeader.attr("collapseId", collapseId + (defaultIsCollapse ? "defaultCollapseKey" : "collapseKey"));
}

export class EditScreenGroup {
    constructor(group, metaData, presenter) {
        this.group = group;
        this.metaData = metaData;
        this.presenter = presenter;
    }

    drawGroup(group, metaData, presenter, groupNumber, groupHeader) {
        let that = this;
        that.presenter = presenter;
        let container = that.createGroupContainer(group ? group.title : "", presenter, groupHeader, groupNumber);
        let widgetsList = this.widgetsList = container.find(".widgetsList").length == 0 ? container : container.find(".widgetsList");
        that.groupNumber = groupNumber;
        if (!that.groupHandler)
            that.groupHandler = new EditScreenGroupHandler(widgetsList, that.rootElement, presenter);
        if (!group || !group.fields)
            return container;
        for (let field of group.fields) {
            that.renderField({field, metaData, presenter, widgetsList, groupNumber: groupNumber});
            //
        }
        return widgetsList.html() && widgetsList.find(".widgetContainer").length ? container : null;
    }

    appendElement(field, metaData, presenter) {
        this.renderField({field, metaData, presenter, widgetsList: this.widgetsList, groupNumber: this.groupNumber});
    }

    shouldAddMainFileContainer(presenter) {
        let that = this;
        let isFirstGroup = presenter.noGroupsAdded;
        if (!isFirstGroup)
            return false;
        return isFirstGroup && shouldAddMainFileWidget(presenter.entityType);
    }


    createGroupContainer(title, presenter, groupHeader, groupNumber) {
        let that = this;
        let groupTitle = $.trim(ts.translateNaMaText(title)) || "";
        let groupId = title ? title.resourceId : "p" + presenter.currentPageIndex + "g" + groupNumber;
        let container = that.rootElement ? that.rootElement() : null;
        if (groupHeader) {
            groupHeader.attr("id", groupId);
            setItemCollapseAttr(presenter, groupHeader, groupId);

            groupHeader.find("span").text(groupTitle);
            container = groupHeader.parent().find(".info-body");
        }
        if (groupNumber == 0 && presenter && that.shouldAddMainFileContainer(presenter)) {
            container.attr("id", "groupImgContainer");
            let groupAndImgContainer = $(`<div class="form-group col-md-6 mb-1"><div class=" row align-items-center w-100 mx-auto mb-1">
<div class="col-lg-2 px-1 text-lg-right col-form-label control-label" id ="imageLabel"><label for class="mb-2 mb-lg-0"></label></div>
<div id ="mainFileContainer" class="form-group col-lg-4 px-1 mb-2 mb-lg-0"></div><div id="inputContainer" class="col-lg-6 px-1"></div></div></div>`);
            groupAndImgContainer.find("#imageLabel").find("label").text(translateId("Image"));
            let mainFileWidthPercent = calcMainFileWidthPercent(presenter.entityType);
            if (mainFileWidthPercent) {
                groupAndImgContainer.find("#mainFileContainer").removeClass("col-md-6");
                groupAndImgContainer.find("#mainFileContainer").removeClass("mb-1");
                groupAndImgContainer.find("#mainFileContainer").width(mainFileWidthPercent + "%");
            }
            let fieldMetadata = findFieldMetadata("mainFile", presenter.metaData);
            let mainFileWidget = new AttachmentWidget({owner: presenter, fieldMetadata, id: "mainFile"});
            presenter.addDataWidget(mainFileWidget);
            mainFileWidget.render().appendTo(groupAndImgContainer.find("#inputContainer"));
            container.append(groupAndImgContainer);
        }
        return container;

    }

    renderField({field, metaData, presenter, widgetsList, compositeField, groupNumber, isFirstCompositePart, subFieldsLength}) {
        let that = this;
        if (field.subFields && field.subFields.length) {
            that.drawCompositeField(field, metaData, presenter, widgetsList, groupNumber);
        } else {
            that.groupHandler.addWidget(field, metaData, presenter, that.findMetadata(field), compositeField, groupNumber, null, isFirstCompositePart, subFieldsLength);
        }
    };

    drawCompositeField(field, metaData, presenter, widgetsList, groupNumber) {
        let that = this;
        if (isMobileDevice()) {
            for (let i = 0; i < field.subFields.length; i++) {
                let subField = field.subFields[i];
                that.renderField({
                    field: subField,
                    metaData,
                    presenter,
                    widgetsList,
                    compositeField: field,
                    groupNumber: groupNumber,
                    isFirstCompositePart: i === 0,
                    subFieldsLength: field.subFields.length
                });
            }
            return;
        }
        for (let i = 0; i < field.subFields.length; i++) {
            let subField = field.subFields[i];
            that.renderField({
                field: subField, metaData, presenter, widgetsList, compositeField: field, groupNumber: groupNumber,
                isFirstCompositePart: i == 0, subFieldsLength: field.subFields.length
            });
        }
    }

    findMetadata(field) {
        let that = this;
        if (!that.questionEditor)
            return null;
        return createFieldMetadata(field);
    }
}

class EditScreenGroupHandler {

    constructor(widgetsList, rootElement, presenter) {
        let that = this;
        that.widgetsList = widgetsList;
        that.presenter = presenter;
        that.fieldNumber = 0;
        that.rootElement = rootElement;
        that.fieldsNextToImgCount = 0;
    }

    /**
     *
     * @param {String} title
     * @param {any} widget
     * @param {namaTypes.EditScreenField} field
     */
    addWidget(field, entityMetaData, presenter, fieldMetadata, compositeField, groupNumber, predefinedWidget,
              isFirstCompositePart, subFieldsLength) {
        let that = this;
        let widget = predefinedWidget;
        if (!widget) {
            if (!fieldMetadata)
                fieldMetadata = meta.findFieldMetadata(field.id, entityMetaData);
            if (!fieldMetadata)
                return "";
            if (!isFeatureEnabled(fieldMetadata.relatedToFeature))
                return "";
            if (fieldMetadata.fieldType === FieldType.Reference && !isFeatureEnabled(fieldMetadata.referencedEntityType))
                return "";
            if (presenter && !userCanViewField(presenter.entityType, field.id))
                return "";
            let req = {fieldMetadata: fieldMetadata, owner: presenter, width: getFieldWidth(field)};
            if (that.rootElement && !req.owner.rootElement)
                req.owner.rootElement = that.rootElement;
            widget = intiWidget_(field, entityMetaData, presenter, fieldMetadata, req);
        }
        that.addNewLine(subFieldsLength, isFirstCompositePart);
        let widgetKlass = "col-lg-10";
        let aloneFieldWithoutImg = !that.mustAddFieldNextToImg() && field.layout === EditScreenFieldLayout.alone;
        if (that.oneFieldPerLine(field) || aloneFieldWithoutImg) {
            that.lastRow.removeClass("col-md-6");
            that.lastRow.addClass("col-12");
            widgetKlass = "col-lg-11";
        }
        if (aloneFieldWithoutImg) {
            widgetKlass = "col-lg-10";
            let innerDiv = $(`<div class="row align-items-center w-100 m-auto"><div class="col-md-6 aloneFieldWithoutImg">
            <div class="row align-items-center w-100 m-auto"></div>
            </div></div>`);
            that.lastRow.append(innerDiv);
        }
        let ownerId = entityMetaData && entityMetaData.owner ? entityMetaData.owner.ownerId : null;
        if (!isMobileDevice() && isFirstCompositePart && subFieldsLength > 2) {
            let label = that.addWidgetLabel(ownerId, compositeField, null, fieldMetadata, groupNumber, predefinedWidget, subFieldsLength);
            label.insertBefore(that.widgetsList.find(".compositeContainer:last"));
        }
        if (!compositeField || (compositeField && (isFirstCompositePart || field.hasTitle))) {
            let label = that.addWidgetLabel(ownerId, field, compositeField ? field : null, fieldMetadata, groupNumber, predefinedWidget, subFieldsLength);
            that.lastRow.find(".row:last").append(label);
        }
        let widgetDiv;
        let divExist = false;
        if (!isMobileDevice() && compositeField) {
            widgetKlass = subFieldsLength == 2 ? "col-lg-5 px-1" : "col-lg-8 px-1";
            if (isFirstCompositePart)
                widgetKlass += " _col";
            widgetDiv = that.lastRow.find("#" + that.createFieldId(field, groupNumber));
            if (!widgetDiv || !widgetDiv.length)
                widgetDiv = $(`<div id = ${that.createFieldId(field, groupNumber)} class="${widgetKlass}"></div>`);
            else
                divExist = true;
            that.appendWidgetToParent(widget, widgetDiv);
        } else {
            widgetDiv = $(`<div id = ${that.createFieldId(field, groupNumber)} class= "${widgetKlass} px-1"></div>`);
            that.appendWidgetToParent(widget, widgetDiv);
        }
        if (!divExist)
            that.lastRow.find(".row:last").append(widgetDiv);
        that.lastWidget = widget;
    }

    appendWidgetToParent(widget, widgetDiv) {
        let that = this;
        if (widget instanceof BooleanFieldWidget) {
            let label = that.lastRow.find(".row:last").find("label");
            let labelParent = that.lastRow.find(".row:last").find("label").parent();
            label.remove();
            labelParent.append(widget.render());
            labelParent.addClass("col-1");
            widgetDiv.addClass("check-box-label col-11").append(label);
        } else {
            widgetDiv.append(widget.render());
        }
    }

    addWidgetLabel(ownerId, field, compositeField, fieldMetadata, groupNumber, editorWidget, subFieldsLength) {
        let that = this;
        let required = fieldMetadata.required;
        let title = field.customFieldTitle;
        if (!title) {
            let baseTitle = compositeField ? ts.translateTitledId(ownerId, compositeField) : undefined;
            if (isMobileDevice() || !compositeField) {
                title = ts.translateTitledId(ownerId, field);
                if (baseTitle && baseTitle !== title)
                    title = baseTitle + " - " + title;
            } else {
                title = baseTitle;
            }
        }
        if (editorWidget)
            title = translate(field.id, ownerId);
        ++that.fieldNumber;
        let labelWidth = "col-lg-2 px-1 text-lg-right";
        if (that.oneFieldPerLine(field))
            labelWidth = "col-lg-1 px-1 text-lg-right";
        if (!isMobileDevice() && compositeField && subFieldsLength > 2)
            labelWidth = "col-lg-4 px-1 text-lg-right";
        let labelContainer = $(`<div class="${labelWidth} col-form-label control-label">
        <a href="#" title="${translateId("help")}" id="helpLink" class="k-icon k-i-help" style="display: none"></a>
        <label class ="fieldLabel mb-2 mb-lg-0" for="${that.createFieldId(field, groupNumber)}">${title}</label></div>`);
        if (required)
            labelContainer.addClass("required-field");
        if (shouldShowHelpMsgs()) {
            let helpLink = labelContainer.find("#helpLink");
            helpLink.css("display", "inline-flex");
            helpLink.on("click", (e) => {
                e.preventDefault();
                /**
                 *
                 * @type {namaTypes.DTOHelpMessagesRequest}
                 */
                let reqData = {
                    fieldId: field.id,
                    entityType: ownerId
                };
                findHelpMsgAndShowIt(reqData);
            });
        }
        return labelContainer;
    }

    oneFieldPerLine(field) {
        return !this.mustAddFieldNextToImg() && (field.layout === EditScreenFieldLayout.startnewline || field.layout === EditScreenFieldLayout.spanned || field.layout === EditScreenFieldLayout.spanned2);
    }

    createFieldId(field, groupNumber) {
        return field.id + groupNumber + this.fieldNumber;
    }

    addNewLine(subFieldsLength, isFirstCompositePart) {
        let that = this;
        if (that.mustAddFieldNextToImg()) {
            that.fieldsNextToImgCount++;
            return;
        }
        if (that.lastRow && that.lastRow.find(".row:last").children().length == 0)
            return;
        if (!isMobileDevice() && subFieldsLength == 2 && !isFirstCompositePart)
            return;
        if (isMobileDevice() || !subFieldsLength || subFieldsLength == 2) {
            that.lastRow = $(`<div class="form-group col-md-6 mb-1"><div class=" row align-items-center w-100 m-auto"></div></div>`).appendTo(that.widgetsList);
            return;
        }
        let subKlass = 12 / subFieldsLength;
        let compositeDivKlass = (isFirstCompositePart && subFieldsLength > 2) ? 'col-md-11' : 'col-md-12';
        if (isFirstCompositePart)
            that.lastRow = $(`<div class="compositeContainer form-group row ${compositeDivKlass} mb-1"><div class="col-md-${subKlass} mb-1"><div class=" row align-items-center w-100 m-auto"></div></div></div>`).appendTo(that.widgetsList);
        else
            $(`<div class="col-md-${subKlass} mb-1"><div class=" row align-items-center w-100 m-auto"></div></div>`).appendTo(that.lastRow);
    }

    mustAddFieldNextToImg() {
        let that = this;
        return that.presenter.noGroupsAdded && that.lastRow && that.fieldsNextToImgCount < 6 && that.lastRow.parent().find("#mainFileContainer").length > 0;
    }
}


export function newLine() {
    return $(`<div class="clearfix"/>`);
}

export function calcMainFileWidthPercent(entityType) {
    let entityImageInfo = getEntityImageInfo(entityType);
    if (entityImageInfo == null || isNullOrUndefined(entityImageInfo.mainFileWidthPercent) || entityImageInfo.mainFileWidthPercent == 0)
        return 0;
    return entityImageInfo.mainFileWidthPercent;
}
